import { gql } from '@apollo/client';

export const IMAGE_FRAGMENT = gql`
  fragment image on ImageNode {
    alt
    height
    id
    src
    width
  }
`;

export const IMAGE_SET_FRAGMENT = gql`
  fragment imageSet on ImageSetNode {
    id
    title
    copy
    images {
      id
      copy
      imageTreatment
      social
      title
      url
      image {
        ...image
      }
    }
  }
`;

export const IMAGE_UPLOAD_MUTATION = gql`
  ${IMAGE_FRAGMENT}
  mutation ImageUpload($file: Upload!, $folderName: String!, $title: String!) {
    imageUpload(file: $file, folderName: $folderName, title: $title) {
      image {
        ...image
      }
      success
    }
  }
`;
